<template>
  <div :class="{ loader__infinity: small, loader__base: !small }" ref="target">
    <div class="loader" :class="{ 'loader--small': small }"></div>
  </div>
</template>

<script>
/**
 * ローディングインディケータ
 */
export default {
  name: 'LoadingIndicator',
  props: {
    /** 無限スクロール表示用 */
    small: Boolean,
  },
  mounted() {
    /**
     * 直親要素にpositionの指定がない場合'relative'を指定
     */
    const _parent = this.$refs.target.parentElement
    const _style = _parent && window.getComputedStyle(_parent)
    if (_style && _style.getPropertyValue('position') === 'static' && !this.small) {
      _parent.style.position = 'relative'
    }
  },
}
</script>

<style lang="postcss" scoped>
.loader {
  animation: spin 0.75s infinite linear;
  border: 4px solid var(--dark-gray);
  border-radius: 50%;
  border-top-color: transparent;
  box-sizing: border-box;
  display: inline-block;
  height: 80px;
  position: relative;
  width: 80px;

  &::before,
  &::after {
    border: inherit;
    border-radius: inherit;
    box-sizing: border-box;
    content: '';
    display: none;
    height: inherit;
    left: -4px;
    position: absolute;
    top: -4px;
    width: inherit;
  }

  &::after {
    display: block;
    transform: rotate(65deg);
  }

  &--small {
    border: 2px solid var(--dark-gray);
    border-top-color: transparent;
    height: 32px;
    width: 32px;

    &::before,
    &::after {
      left: -2px;
      top: -2px;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loader__base {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2000;

  .responsive & {
    position: fixed;
  }
}

.loader__infinity {
  align-items: center;
  display: flex;
  height: 60px;
  justify-content: center;
  width: 100%;
}
</style>
